import { Action } from '@ngrx/store';
import { ICharitableContribution } from 'src/commons';

export enum CharitableContributionActionTypes {
  LoadCharitableContributionState = '[CharitableContribution] Load CharitableContribution State',
  LoadCharitableContributionStateSuccess = '[CharitableContribution] Load CharitableContribution State Success',
  LoadCharitableContributionStateFail = '[CharitableContribution] Load CharitableContribution State Fail',
  CharitableContributionScreenErrorReset = '[CharitableContribution] CharitableContribution Screen Error Reset'

}

export class LoadCharitableContributionState implements Action {
  readonly type = CharitableContributionActionTypes.LoadCharitableContributionState;
  constructor(public formId: number) {}
}

export class LoadCharitableContributionStateSuccess implements Action {
  readonly type = CharitableContributionActionTypes.LoadCharitableContributionStateSuccess;
  constructor(public payload: ICharitableContribution ) {}
}

export class LoadCharitableContributionStateFail implements Action {
  readonly type = CharitableContributionActionTypes.LoadCharitableContributionStateFail;
  constructor(public payload: any) {}
}

export class CharitableContributionScreenErrorReset implements Action {
  readonly type = CharitableContributionActionTypes.CharitableContributionScreenErrorReset;
}

export type CharitableContributionActions = 
  LoadCharitableContributionState
  | LoadCharitableContributionStateSuccess
  | LoadCharitableContributionStateFail
  | CharitableContributionScreenErrorReset;